export enum CompanySelectionModeEnum {
    Manual = 'manual',
    AllBrandCompanies = 'allFromBrand',
}
